// import React, { useState, useEffect, useRef } from 'react';
// import Cookies from 'js-cookie';
// import InformationModal from '../components/InformationModal';
// import { IoMdInformationCircleOutline } from "react-icons/io";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// function DualRangeSlider({
//   min = 0,
//   max = 1000,
//   defaultFromValue = 0,
//   defaultToValue = 1000,
//   onChange = () => {},
// }) {
//   const [fromValue, setFromValue] = useState(defaultFromValue);
//   const [toValue, setToValue] = useState(defaultToValue);
//   const [activeDragger, setActiveDragger] = useState(null);
//   const rangeRef = useRef(null);
//   const containerRef = useRef(null);

//   const getPercent = (value) => ((value - min) / (max - min)) * 100;

//   // Update range style + trigger onChange
//   useEffect(() => {
//     if (rangeRef.current) {
//       const fromPercent = getPercent(fromValue);
//       const toPercent = getPercent(toValue);
//       rangeRef.current.style.left = `${fromPercent}%`;
//       rangeRef.current.style.width = `${toPercent - fromPercent}%`;
//     }
//     onChange({ from: fromValue, to: toValue });
//   }, [fromValue, toValue, min, max]);

//   // Handle drag logic
//   useEffect(() => {
//     const handlePointerMove = (e) => {
//       if (!activeDragger || !containerRef.current) return;

//       const rect = containerRef.current.getBoundingClientRect();
//       const position = (e.clientX - rect.left) / rect.width;
//       const newValue = Math.round(position * (max - min) + min);

//       if (activeDragger === "from") {
//         setFromValue(Math.max(min, Math.min(toValue, newValue)));
//       } else if (activeDragger === "to") {
//         setToValue(Math.min(max, Math.max(fromValue, newValue)));
//       }
//     };

//     const handlePointerUp = () => {
//       setActiveDragger(null);
//     };

//     if (activeDragger) {
//       document.addEventListener("pointermove", handlePointerMove);
//       document.addEventListener("pointerup", handlePointerUp);
//     }

//     return () => {
//       document.removeEventListener("pointermove", handlePointerMove);
//       document.removeEventListener("pointerup", handlePointerUp);
//     };
//   }, [activeDragger, min, max, fromValue, toValue]);

//   return (
//     <>
//       <div className="dual-range-slider">
//         <div className="slider-container" ref={containerRef}>
//           <div className="slider-track">
//             <div ref={rangeRef} className="slider-range" />
//           </div>

//           {/* From dragger */}
//           <div
//             className="slider-dragger"
//             style={{ left: `${getPercent(fromValue)}%` }}
//             onPointerDown={() => setActiveDragger("from")}
//           >
//             <div className="slider-value">{fromValue}</div>
//           </div>

//           {/* To dragger */}
//           <div
//             className="slider-dragger"
//             style={{ left: `${getPercent(toValue)}%` }}
//             onPointerDown={() => setActiveDragger("to")}
//           >
//             <div className="slider-value">{toValue}</div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         .dual-range-slider {
//           display: flex;
//           flex-direction: column;
//           width: 100%;
//         }
//         .slider-container {
//           position: relative;
//           height: 48px;
//           width: 100%;
//           touch-action: none; /* prevent scrolling while dragging */
//         }
//         .slider-track {
//           position: absolute;
//           top: 24px;
//           height: 4px;
//           width: 100%;
//           background-color: #d1d5db;
//           border-radius: 9999px;
//         }
//         .slider-range {
//           position: absolute;
//           height: 100%;
//           background-color: #ee373b;
//           border-radius: 9999px;
//         }
//         .slider-dragger {
//           position: absolute;
//           top: 20px;
//           width: 16px;
//           height: 16px;
//           background-color: #ee373b;
//           border: 2px solid #ee373b;
//           border-radius: 50%;
//           cursor: pointer;
//           transform: translateX(-50%);
//           touch-action: none;
//         }
//         .slider-value {
//           position: absolute;
//           top: -32px;
//           left: 50%;
//           font-weight: bold;
//           transform: translateX(-50%);
//           font-size: 1rem;
//           color: #4b5563;
//         }
//       `}</style>
//     </>
//   );
// };

// const CustomCarousel = ({ images }) => {
//     const [currentIndex, setCurrentIndex] = useState(0);
//     const [isZoomed, setIsZoomed] = useState(false);
//     const [zoomedImage, setZoomedImage] = useState(null);

//     const goToPrevious = () => {
//         const isFirstImage = currentIndex === 0;
//         const newIndex = isFirstImage ? images.length - 1 : currentIndex - 1;
//         setCurrentIndex(newIndex);
//     };

//     const goToNext = () => {
//         const isLastImage = currentIndex === images.length - 1;
//         const newIndex = isLastImage ? 0 : currentIndex + 1;
//         setCurrentIndex(newIndex);
//     };

//     const handleImageClick = (image) => {
//         setZoomedImage(image);
//         setIsZoomed(true);
//     };

//     const handleKeyDown = (e) => {
//         if (e.key === 'Escape') {
//             setIsZoomed(false);
//         }
//     };

//     useEffect(() => {
//         if (isZoomed) {
//             document.addEventListener('keydown', handleKeyDown);
//         } else {
//             document.removeEventListener('keydown', handleKeyDown);
//         }
//         return () => {
//             document.removeEventListener('keydown', handleKeyDown);
//         };
//     }, [isZoomed]);

//     return (
//         <div className="custom-carousel">
//             <div className="carousel-main-image">
//                 <button onClick={goToPrevious} className="carousel-button">
//                     <IoIosArrowBack />
//                 </button>
//                 <img
//                     src={images[currentIndex]}
//                     alt={`Car view ${currentIndex + 1}`}
//                     // style={{ height: '62vh', width: '35vw' }}
//                     className="carousel-img-car"
//                     // onClick={() => handleImageClick(images[currentIndex])}
//                 />
//                 <button onClick={goToNext} className="carousel-button">
//                     <IoIosArrowForward />
//                 </button>
//             </div>

//             {isZoomed && (
//                 <div className="zoom-modal" onClick={() => setIsZoomed(false)}>
//                     <button className="close-button" onClick={() => setIsZoomed(false)}>
//                         ×
//                     </button>
//                     <img
//                         src={zoomedImage}
//                         alt="Zoomed view"
//                         className="zoomed-image"
//                         onClick={(e) => e.stopPropagation()}
//                     />
//                 </div>
//             )}

//             <style jsx>{`
//                 .custom-carousel {
//                     display: flex;
//                     flex-direction: column;
//                     align-items: center;
//                     gap: 10px;
//                 }
//                 .carousel-main-image {
//                     display: flex;
//                     justify-content: center;
//                     gap: 10px;
//                     align-items: center;
//                     height: 60vh;
//                     overflow: hidden;
//                 }
//                 .carousel-main-image img {
//                     max-height: 100%;
//                     max-width: 100%;
//                     object-fit: contain;
//                     cursor: pointer;
//                 }
//                 .carousel-button {
//                     background: none;
//                     border: none;
//                     font-size: 24px;
//                     cursor: pointer;
//                     color: #ee373b;
//                 }
//                 .zoom-modal {
//                     position: fixed;
//                     top: 0;
//                     left: 0;
//                     width: 100vw;
//                     height: 100vh;
//                     background: rgba(0, 0, 0, 0.9);
//                     display: flex;
//                     justify-content: center;
//                     align-items: center;
//                     z-index: 1000;
//                 }
//                 .zoomed-image {
//                     width: 80vh;
//                     height: 80vh;
//                     object-fit: cover;
//                 }
//                 .close-button {
//                     position: absolute;
//                     top: 20px;
//                     right: 20px;
//                     background: none;
//                     border: none;
//                     font-size: 24px;
//                     color: white;
//                     cursor: pointer;
//                 }
//                 .carousel-img-car{
//                     height: 62vh;
//                     width: 35vw;
//                 }
//                 @media(max-width: 450px){
//                     .carousel-img-car{
//                         width: 60vw;
//                     }
//                 }
//             `}</style>
//         </div>
//     );
// };

// const CarCard = ({ car, showModal, showImageModal, formatCurrency, formatDate }) => {
//   return (
//     <div className="car-card">
//       <div className="car-card-header">
//         <h3>{car.make} {car.model} ({car.year})</h3>
//         <div className="car-badges">
//           <span className={`status-badge ${car.allowed === 'y' ? 'status-active' : 'status-inactive'}`}>
//             {car.allowed === 'y' ? 'Active' : 'Inactive'}
//           </span>
//           <span className={`event-badge ${car.usedInEvent ? 'in-event' : 'not-in-event'}`}>
//             {car.usedInEvent ? 'In Event' : 'Available'}
//           </span>
//         </div>
//       </div>
//       <div className="car-card-body">
//         <div className="car-card-row">
//           <span className="car-card-label">Reg. Number:</span>
//           <span className="car-card-value">{car.registrationNo}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Price:</span>
//           <span className="car-card-value">{formatCurrency(car.startPrice)}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Insurance:</span>
//           <span className="car-card-value">{car.insurance}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">RC Status:</span>
//           <span className="car-card-value">{car.rcRequired}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Color:</span>
//           <span className="car-card-value">{car.color}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Odometer:</span>
//           <span className="car-card-value">{car.odometer}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Fuel:</span>
//           <span className="car-card-value">{car.fuel}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Transmission:</span>
//           <span className="car-card-value">{car.transmission}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Available From:</span>
//           <span className="car-card-value">{formatDate(car.availableStartDateAndTime)}</span>
//         </div>
//         <div className="car-card-row">
//           <span className="car-card-label">Available To:</span>
//           <span className="car-card-value">{formatDate(car.availableEndDateAndTime)}</span>
//         </div>
//       </div>
//       <div className="car-card-footer">
//         {car.images && car.images.length > 0 && (
//           <button onClick={() => showImageModal(car.images)} className="view-images-button">
//             View Images
//           </button>
//         )}
//         <button disabled={car.usedInEvent} onClick={() => showModal(car)} className={`edit-button-${car.usedInEvent ? "disabled" : "enabled"}`}>
//           Edit
//         </button>
//       </div>
//       <style>{`
//         /* Compact car card styles */
//         .car-card {
//           border: 1px solid var(--border-color, #e5e7eb);
//           border-radius: var(--border-radius, 8px);
//           padding: 12px 16px;
//           background-color: var(--bg-primary, white);
//           box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//           margin-bottom: 16px;
//           transition: box-shadow 0.2s ease;
//         }

//         .car-card:hover {
//           box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
//         }

//         .car-card-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: flex-start;
//           margin-bottom: 12px;
//           gap: 12px;
//         }

//         .car-card-header h3 {
//           margin: 0;
//           font-size: 16px;
//           font-weight: 600;
//           color: var(--text-primary, #111827);
//           line-height: 1.3;
//           word-wrap: break-word;
//           flex: 1;
//           min-width: 0;
//         }

//         .car-badges {
//           display: flex;
//           flex-direction: column;
//           gap: 4px;
//           flex-shrink: 0;
//         }

//         .status-badge, .event-badge {
//           font-size: 10px;
//           font-weight: 500;
//           padding: 3px 8px;
//           border-radius: 12px;
//           text-align: center;
//           white-space: nowrap;
//         }

//         .status-active {
//           background: #dcfce7;
//           color: #166534;
//         }

//         .status-inactive {
//           background: #fef2f2;
//           color: #dc2626;
//         }

//         .in-event {
//           background: #fef3c7;
//           color: #d97706;
//         }

//         .not-in-event {
//           background: #e0f2fe;
//           color: #0369a1;
//         }

//         .car-card-body {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 6px 12px;
//         }

//         @media (max-width: 768px) {
//           .car-card-body {
//             grid-template-columns: repeat(2, 1fr);
//             gap: 6px 8px;
//           }
//         }

//         @media (max-width: 480px) {
//           .car-card-body {
//             grid-template-columns: 1fr;
//             gap: 4px;
//           }
          
//           .car-card-header {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 8px;
//           }
          
//           .car-badges {
//             flex-direction: row;
//             gap: 6px;
//           }
//         }

//         .car-card-row {
//           display: flex;
//           flex-direction: column;
//           gap: 2px;
//           min-width: 0;
//         }

//         .car-card-label {
//           font-size: 10px;
//           color: var(--text-secondary, #6b7280);
//           font-weight: 500;
//           text-transform: uppercase;
//           letter-spacing: 0.025em;
//         }

//         .car-card-value {
//           font-size: 13px;
//           color: var(--text-primary, #111827);
//           font-weight: 500;
//           word-wrap: break-word;
//           line-height: 1.3;
//         }

//         .car-card-footer {
//           display: flex;
//           justify-content: flex-end;
//           gap: 8px;
//           margin-top: 12px;
//           padding-top: 12px;
//           border-top: 1px solid var(--border-color, #f3f4f6);
//         }

//         .view-images-button {
//           background-color: var(--bg-secondary, #f3f4f6);
//           color: var(--text-primary, #374151);
//           border: 1px solid var(--border-color, #d1d5db);
//           border-radius: var(--border-radius, 6px);
//           padding: 6px 12px;
//           font-size: 12px;
//           font-weight: 500;
//           cursor: pointer;
//           transition: all var(--transition-speed, 0.2s) ease;
//           white-space: nowrap;
//         }

//         .view-images-button:hover {
//           background-color: var(--bg-primary, #e5e7eb);
//           box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//         }

//         .edit-button-enabled {
//           background-color: #3b82f6;
//           color: white;
//           border: 1px solid #3b82f6;
//           border-radius: var(--border-radius, 6px);
//           padding: 6px 12px;
//           font-size: 12px;
//           font-weight: 500;
//           cursor: pointer;
//           transition: all var(--transition-speed, 0.2s) ease;
//           white-space: nowrap;
//         }

//         .edit-button-enabled:hover {
//           background-color: #2563eb;
//           border-color: #2563eb;
//         }

//         .edit-button-disabled {
//           background-color: #f9fafb;
//           color: #9ca3af;
//           border: 1px solid #e5e7eb;
//           border-radius: var(--border-radius, 6px);
//           padding: 6px 12px;
//           font-size: 12px;
//           font-weight: 500;
//           cursor: not-allowed;
//           white-space: nowrap;
//         }

//         @media (max-width: 480px) {
//           .car-card-footer {
//             flex-direction: column;
//             gap: 6px;
//           }
          
//           .view-images-button,
//           .edit-button-enabled,
//           .edit-button-disabled {
//             width: 100%;
//             text-align: center;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// const SortIndicator = ({ sortConfig }) => {
//   if (!sortConfig.key) return null;

//   const keyToLabel = {
//     'registrationNo': 'Reg. Number',
//     'make': 'Car Details',
//     'startPrice': 'Base Price',
//     'insurance': 'Insurance Status',
//     'rcRequired': 'RC Status',
//     'color': 'Color',
//     'odometer': 'Odometer',
//     'fuel': 'Fuel',
//     'transmission': 'Transmission',
//     'allowed': 'Live Availability',
//     'availableStartDateAndTime': 'Available From',
//     'availableEndDateAndTime': 'Available To',
//     'usedInEvent': 'In Event'
//   };

//   const label = keyToLabel[sortConfig.key] || sortConfig.key;
//   const direction = sortConfig.direction === 'ascending' ? '↑' : '↓';

//   return (
//     <div className="sort-indicator-mobile">
//       Sorted by: {label} {direction}
//     </div>
//   );
// };

// const CarTable = () => {
//   const [cars, setCars] = useState([]);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedCar, setSelectedCar] = useState(null);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
//   const [priceRange, setPriceRange] = useState([0, 1000000]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');
//   const [isImageModalOpen, setIsImageModalOpen] = useState(false);
//   const [selectedCarImages, setSelectedCarImages] = useState([]);
//   const [isMobileView, setIsMobileView] = useState(false);

//   const dateRef1 = useRef();
//   const dateRef2 = useRef();
//   const today = new Date().toISOString().split("T")[0];

//   useEffect(() => {
//     fetchCars();
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobileView(window.innerWidth <= 768);
//     };

//     handleResize();
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   const fetchCars = async () => {
//     const sellerId = Cookies.get("adminSellerId");
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/dealer/cars-manage/${sellerId}`, {
//         credentials: "include",
//         headers: {
//           "X-Full-URL": window.location.href,
//         }
//       });
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
//       const data = await response.json();
//       setCars(data);
//     } catch (error) {
//       console.error('Error fetching cars:', error);
//     }
//   };

//   const showModal = (car) => {
//     setSelectedCar(car);
//     setIsModalVisible(true);
//   };

//   const handleOk = async () => {
//     try {
//       const formattedSelectedCar = {
//         ...selectedCar,
//         availableStartDateAndTime: formatDateTime(selectedCar.availableStartDateAndTime),
//         availableEndDateAndTime: formatDateTime(selectedCar.availableEndDateAndTime),
//       };
//       const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/dealer/cars-manage/update`, {
//         method: 'PUT',
//         headers: {
//           'Content-Type': 'application/json',
//           "X-Full-URL": window.location.href,
//         },
//         body: JSON.stringify(formattedSelectedCar),
//         credentials: "include"
//       });
//       if (response.ok) {
//         setModalMessage("Car Details Updated");
//         setIsModalOpen(true);
//       }
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
//       setIsModalVisible(false);
//       fetchCars();
//     } catch (error) {
//       console.error('Error updating car details:', error);
//     }
//   };

//   const formatDateTime = (dateString) => {
//     if (!dateString) return null;
//     const date = new Date(dateString);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const hours = String(date.getHours()).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const seconds = String(date.getSeconds()).padStart(2, '0');
//     return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
//   };

//   const handleCancel = () => {
//     setIsModalVisible(false);
//   };

//   const handleInputChange = (e, field) => {
//     setSelectedCar({
//       ...selectedCar,
//       [field]: e.target.value
//     });
//   };

//   const handleToggleChange = (e) => {
//     setSelectedCar({
//       ...selectedCar,
//       allowed: e.target.checked ? 'y' : 'n'
//     });
//   };

//   const handleDateChange = (dates) => {
//     setSelectedCar({
//       ...selectedCar,
//       availableStartDateAndTime: dates[0],
//       availableEndDateAndTime: dates[1],
//     });
//   };

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const handleSort = (key) => {
//     let direction = 'ascending';
//     if (sortConfig.key === key && sortConfig.direction === 'ascending') {
//       direction = 'descending';
//     }
//     setSortConfig({ key, direction });
//   };

//   const handlePriceRangeChange = (range) => {
//     setPriceRange([range.from, range.to]);
//   };

//   const showImageModal = (images) => {
//     setSelectedCarImages(images);
//     setIsImageModalOpen(true);
//   };

//   const closeImageModal = () => {
//     setIsImageModalOpen(false);
//   };

//   const handleFocusFirst = () => {
//     if (dateRef1.current?.showPicker) {
//       dateRef1.current.showPicker();
//     }
//   };

//   const handleFocusSecond = () => {
//     if (dateRef2.current?.showPicker) {
//       dateRef2.current.showPicker();
//     }
//   };

//   const formatCurrency = (value) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 0
//     }).format(value);
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return '-';
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const minPrice = Math.min(...cars.map(car => car.startPrice), 0);
//   const maxPrice = Math.max(...cars.map(car => car.startPrice), 1000000);

//   const filteredCars = cars
//     .filter(car => {
//       const searchTermLower = searchTerm.toLowerCase();
//       return Object.values(car).some(value =>
//         String(value).toLowerCase().includes(searchTermLower)
//       );
//     })
//     .filter(car => car.startPrice >= priceRange[0] && car.startPrice <= priceRange[1])
//     .sort((a, b) => {
//       if (!sortConfig.key) return 0;
//       if (a[sortConfig.key] < b[sortConfig.key]) {
//         return sortConfig.direction === 'ascending' ? -1 : 1;
//       }
//       if (a[sortConfig.key] > b[sortConfig.key]) {
//         return sortConfig.direction === 'ascending' ? 1 : -1;
//       }
//       return 0;
//     });

//   return (
//     <div className="car-management-container">
//       <InformationModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         message={modalMessage}
//       />

//       <div className="page-header">
//         <h1>Vehicle Inventory Management</h1>
//       </div>

//       <div className="filters-container">
//         <div className="search-container">
//           <input
//             type="text"
//             placeholder="Search vehicles..."
//             value={searchTerm}
//             onChange={handleSearch}
//             id="search-input"
//           />
//         </div>
//         <div className="price-filter">
//           <label htmlFor="price-range-input">Price Range: {formatCurrency(priceRange[0])} - {formatCurrency(priceRange[1])}</label>
//           <DualRangeSlider
//             min={minPrice}
//             max={maxPrice}
//             defaultFromValue={minPrice}
//             defaultToValue={maxPrice}
//             onChange={handlePriceRangeChange}
//           />
//         </div>
//       </div>

//       <div className="content-container">
//         {/* Desktop view - Table */}
//         {!isMobileView && (
//           <div className="table-scroll-container">
//             <table id="car-table">
//               <thead>
//                 <tr>
//                   <th onClick={() => handleSort('registrationNo')}>
//                     Reg. Number
//                     {sortConfig.key === 'registrationNo' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('year')}>
//                     Car Details
//                     {sortConfig.key === 'make' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('startPrice')}>
//                     Base Price
//                     {sortConfig.key === 'startPrice' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('insurance')}>
//                     Insurance Status
//                     {sortConfig.key === 'insurance' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('rcRequired')}>
//                     RC Status
//                     {sortConfig.key === 'rcRequired' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('color')}>
//                     Color
//                     {sortConfig.key === 'color' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('odometer')}>
//                     Odometer
//                     {sortConfig.key === 'odometer' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('fuel')}>
//                     Fuel
//                     {sortConfig.key === 'fuel' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('transmission')}>
//                     Transmission
//                     {sortConfig.key === 'transmission' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('allowed')}>
//                     Live Availability
//                     {sortConfig.key === 'allowed' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('availableStartDateAndTime')}>
//                     Available From
//                     {sortConfig.key === 'availableStartDateAndTime' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('availableEndDateAndTime')}>
//                     Available To
//                     {sortConfig.key === 'availableEndDateAndTime' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th onClick={() => handleSort('usedInEvent')}>
//                     In Event
//                     {sortConfig.key === 'usedInEvent' && (
//                       <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
//                     )}
//                   </th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredCars.length > 0 ? (
//                   filteredCars.map((car) => (
//                     <tr key={car.auctionListId}>
//                       <td className="table-cell">
//                         {car.registrationNo.length > 10 ? car.registrationNo.slice(0,6) : car.registrationNo}
//                         {car.images && car.images.length > 0 && (
//                           <IoMdInformationCircleOutline
//                             onClick={() => showImageModal(car.images)}
//                             style={{ cursor: 'pointer', marginLeft: '5px' }}
//                           />
//                         )}
//                       </td>
//                       <td className="table-cell">{`${car.make} ${car.model} ${car.variant} - ${car.year}`}</td>
//                       <td className="table-cell price-cell">{formatCurrency(car.startPrice)}</td>
//                       <td className="table-cell">{car.insurance}</td>
//                       <td className="table-cell">{car.rcRequired}</td>
//                       <td className="table-cell">{car.color}</td>
//                       <td className="table-cell">{car.odometer}</td>
//                       <td className="table-cell">{car.fuel}</td>
//                       <td className="table-cell">{car.transmission}</td>
//                       <td className="table-cell">
//                         <span className={`status-badge ${car.allowed === 'y' ? 'status-active' : 'status-inactive'}`}>
//                           {car.allowed === 'y' ? 'Active' : 'Inactive'}
//                         </span>
//                       </td>
//                       <td className="table-cell">{formatDate(car.availableStartDateAndTime)}</td>
//                       <td className="table-cell">{formatDate(car.availableEndDateAndTime)}</td>
//                       <td className="table-cell">
//                         <span className={`event-badge ${car.usedInEvent ? 'in-event' : 'not-in-event'}`}>
//                           {car.usedInEvent ? 'Yes' : 'No'}
//                         </span>
//                       </td>
//                       <td className="action-cell">
//                         <button disabled={car.usedInEvent} onClick={() => showModal(car)} className={`edit-button-${car.usedInEvent ? "disabled" : "enabled"}`}>
//                           Edit
//                         </button>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="20" className="no-results">No vehicles match your search criteria</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         )}

//         {/* Mobile view - Cards */}
//         {isMobileView && (
//           <div className="cards-scroll-container">
//             <SortIndicator sortConfig={sortConfig} />
//             <div className="cars-grid">
//               {filteredCars.length > 0 ? (
//                 filteredCars.map((car) => (
//                   <CarCard
//                     key={car.auctionListId}
//                     car={car}
//                     showModal={showModal}
//                     showImageModal={showImageModal}
//                     formatCurrency={formatCurrency}
//                     formatDate={formatDate}
//                   />
//                 ))
//               ) : (
//                 <div className="no-results">No vehicles match your search criteria</div>
//               )}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Edit Car Modal */}
//       {isModalVisible && (
//         <div id="modal-backdrop">
//           <div id="modal-content" style={{ border: "2px solid #ee373b" }}>
//             <div className="modal-header">
//               <h2 id="modal-title">Edit Vehicle Details</h2>
//             </div>
//             <div className="vehicle-summary">
//               <h3 style={{ border: "0px", paddingBottom: "0px" }}>{selectedCar?.make} {selectedCar?.model} {selectedCar?.variant} ({selectedCar?.year})</h3>
//               <p className="reg-number">Registration: {selectedCar?.registrationNo}</p>
//             </div>
//             <form id="edit-car-form">
//               <div className="form-row">
//                 <label id="allowed-label">
//                   Listing Status:
//                   <div className="toggle-container">
//                     <label className="toggle-switch">
//                       <input
//                         type="checkbox"
//                         checked={selectedCar?.allowed === 'y'}
//                         onChange={handleToggleChange}
//                       />
//                       <span className="slider"></span>
//                     </label>
//                     <span className="toggle-label">{selectedCar?.allowed === 'y' ? 'Active' : 'Inactive'}</span>
//                   </div>
//                 </label>
//               </div>
//               <div className="form-row date-inputs">
//                 <label id="available-date-label">Available Date Range:</label>
//                 <div className="date-range-container">
//                   <div className="date-input-group">
//                     <label>From:</label>
//                     <input
//                       type="date"
//                       ref={dateRef1}
//                       onClick={handleFocusFirst}
//                       min={today}
//                       value={selectedCar?.availableStartDateAndTime?.split('T')[0]}
//                       onChange={(e) => handleInputChange(e, 'availableStartDateAndTime')}
//                     />
//                   </div>
//                   <div className="date-input-group">
//                     <label>To:</label>
//                     <input
//                       type="date"
//                       ref={dateRef2}
//                       onClick={handleFocusSecond}
//                       value={selectedCar?.availableEndDateAndTime?.split('T')[0]}
//                       onChange={(e) => handleInputChange(e, 'availableEndDateAndTime')}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </form>
//             <div className="modal-footer" style={{ border: "0px" }}>
//               <button id="modal-cancel-button" onClick={handleCancel}>Cancel</button>
//               <button id="modal-ok-button" onClick={handleOk}>Save Changes</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Image Modal */}
//       {isImageModalOpen && (
//         <div id="modal-backdrop">
//           <div id="image-modal-content">
//             <div className="modal-header">
//               <h2 id="modal-title">Car Images</h2>
//               <button className="close-btn-modal" onClick={closeImageModal}>×</button>
//             </div>
//             <div className="carousel-container">
//               <CustomCarousel images={selectedCarImages} />
//             </div>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         :root {
//           --primary-color: #3498db;
//           --primary-dark: #2980b9;
//           --secondary-color: #2ecc71;
//           --danger-color: #e74c3c;
//           --warning-color: #f39c12;
//           --text-primary: #2c3e50;
//           --text-secondary: #7f8c8d;
//           --bg-primary: #ffffff;
//           --bg-secondary: #f8f9fa;
//           --border-color: #e1e4e8;
//           --shadow-color: rgba(0, 0, 0, 0.1);
//           --border-radius: 8px;
//           --transition-speed: 0.3s;
//         }

//         .car-management-container {
//           font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//           color: var(--text-primary);
//           background-color: white;
//           box-sizing: border-box;
//           border: 2px solid #ee373b;
//           margin: 10px;
//           border-radius: 20px;
//           display: flex;
//           flex-direction: column;
//           height: 85vh; /* Fixed height for the container */
//         }

//         .page-header {
//           margin-bottom: 12px;
//           background-color: #ee373b;
//           text-align: center;
//           border-top-left-radius: 18px;
//           border-top-right-radius: 18px;
//           padding: 10px;
//         }

//         .page-header h1 {
//           font-size: 24px;
//           font-weight: 600;
//           margin: 0;
//           color: white;
//         }

//         .filters-container {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 20px;
//           margin-bottom: 12px;
//           padding: 0px 10px;
//           align-items: center;
//         }

//         .search-container {
//           position: relative;
//           margin-top: 3vh;
//           flex: 1;
//           min-width: 250px;
//         }

//         .search-icon {
//           position: absolute;
//           top: 50%;
//           left: 12px;
//           transform: translateY(-50%);
//           color: var(--text-secondary);
//           font-style: normal;
//         }

//         #search-input {
//           width: 100%;
//           padding: 8px 10px 8px 10px;
//           border: 1px solid #ee373b;
//           border-radius: var(--border-radius);
//           font-size: 14px;
//         }

//         #search-input:focus {
//           outline: none;
//         }

//         .price-filter {
//           flex: 1;
//           min-width: 250px;
//           display: flex;
//           padding: 0px 25px;
//           flex-direction: column;
//         }

//         .price-filter label {
//           font-size: 1rem;
//           font-weight: bold;
//           text-align: center;
//           margin-bottom: 4px;
//           color: #ee373b;
//         }

//         .content-container {
//           flex: 1;
//           overflow: hidden; /* Prevents scrolling of the container itself */
//         }

//         .table-scroll-container {
//           height: 56vh;
//           overflow-y: auto;
//           padding: 0px 10px;
//           scrollbar-color: #ee373b #ffffff ;
//         }

//         .cars-grid {
//           display: grid;
//           grid-template-columns: 1fr;
//           gap: 16px;
//           padding: 16px;
//         }

//         .cards-scroll-container {
//           height: 65vh; /* Fixed height for the cards container */
//           overflow-y: auto; /* Vertical scroll when content overflows */
//         }

//         #car-table {
//           width: 100%;
//           border-collapse: collapse;
//           border: none;
//           font-size: 12px;
//         }

//         #car-table th {
//           background-color: var(--bg-secondary);
//           color: var(--text-primary);
//           font-weight: 600;
//           text-align: left;
//           padding: 3px 1px;
//           font-size: 12px;
//           border-bottom: 2px solid var(--border-color);
//           cursor: pointer;
//           white-space: nowrap;
//           position: sticky;
//           top: 0;
//           transition: background-color var(--transition-speed);
//         }

//         #car-table th:hover {
//           background-color: #e9ecef;
//         }

//         .sort-indicator {
//           color: var(--primary-color);
//           font-weight: bold;
//         }

//         #car-table td {
//           padding: 3px 1px;
//           border-bottom: 1px solid #ee373b;
//           vertical-align: middle;
//           max-width: 100px;
//           font-size: 12px;
//           overflow: hidden;
//           text-wrap: wrap;
//         }

//         #car-table tr:last-child td {
//           border-bottom: none;
//         }

//         .no-results {
//           text-align: center;
//           padding: 40px 0 !important;
//           color: var(--text-secondary);
//           font-style: italic;
//         }

//         .table-cell {
//           max-width: 100px;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           white-space: nowrap;
//         }

//         .price-cell {
//           font-weight: 600;
//           color: var(--text-primary);
//         }

//         .status-badge {
//           display: inline-block;
//           padding: 4px 8px;
//           border-radius: 30px;
//           font-size: 10px;
//           font-weight: 600;
//           text-align: center;
//         }

//         .status-active {
//           background-color: rgba(46, 204, 113, 0.15);
//           color: #27ae60;
//         }

//         .status-inactive {
//           background-color: rgba(231, 76, 60, 0.15);
//           color: #c0392b;
//         }

//         .event-badge {
//           display: inline-block;
//           padding: 4px 8px;
//           min-width: 3vw;
//           border-radius: 4px;
//           font-size: 10px;
//           font-weight: 500;
//           text-align: center;
//         }

//         .in-event {
//           background-color: rgba(46, 204, 113, 0.15);
//           color: #00b050;
//           font-weight: bold;
//         }

//         .not-in-event {
//           background-color: rgba(231, 76, 60, 0.15);
//           color: #c0392b;
//         }

//         .action-cell {
//           text-align: center;
//         }

//         .edit-button-enabled {
//           background-color: var(--danger-color);
//           color: white;
//           border: 1px solid #ee373b;
//           border-radius: 4px;
//           padding: 6px 12px;
//           font-size: 12px;
//           font-weight: 500;
//           cursor: pointer;
//           transition: background-color var(--transition-speed);
//         }

//         .edit-button-disabled {
//           background-color: white;
//           cursor: not-allowed;
//           color: #ee373b;
//           border: 1px solid #ee373b;
//           border-radius: 4px;
//           padding: 6px 12px;
//           font-size: 12px;
//           font-weight: 500;
//           transition: background-color var(--transition-speed);
//         }

//         .edit-button-enabled:hover {
//           background-color: var(--primary-red);
//         }

//         .sort-indicator-mobile {
//           padding: 8px 16px;
//           background-color: var(--bg-secondary);
//           border-radius: var(--border-radius);
//           margin-bottom: 16px;
//           font-size: 12px;
//           color: var(--text-secondary);
//           text-align: center;
//         }

//         #modal-backdrop {
//           position: fixed;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           background: rgba(0, 0, 0, 0.6);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 1000;
//           animation: fadeIn 0.2s ease-out;
//         }

//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         #modal-content, #image-modal-content {
//           background: white;
//           border-radius: 12px;
//           width: 90%;
//           max-width: 550px;
//           box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
//           animation: slideIn 0.3s ease-out;
//           overflow: hidden;
//           border: 2px solid #ee373b;
//           min-height: 80vh;
//           max-height: 80vh;
//           margin-top: 10vh;
//         }

//         @keyframes slideIn {
//           from { transform: translateY(20px); opacity: 0; }
//           to { transform: translateY(0); opacity: 1; }
//         }

//         .modal-header {
//           display: flex;
//           justify-content: space-between !important;
//           align-items: center;
//           padding: 20px 24px !important;
//           border-bottom: 1px solid var(--border-color);
//           background-color: #ee373b;
//         }

//         #modal-title {
//           margin: 0;
//           font-size: 18px;
//           font-weight: 600;
//           color: white;
//         }

//         .close-btn-modal {
//           background: none;
//           border: none;
//           font-size: 24px;
//           font-weight: bold;
//           color: white;
//           cursor: pointer;
//           transition: color var(--transition-speed);
//         }

//         .close-btn-modal:hover {
//           color: var(--danger-color);
//         }

//         .vehicle-summary {
//           padding: 20px 24px;
//           align-items: center;
//           border-bottom: 1px solid var(--border-color);
//           display: flex;
//           gap: 1rem;
//         }

//         .vehicle-summary h3 {
//           margin: 0;
//           font-size: 16px;
//           font-weight: 600;
//           color: var(--text-primary);
//         }

//         .reg-number {
//           margin: 0;
//           font-size: 16px;
//           font-weight: 600;
//           color: var(--text-primary);
//         }

//         #edit-car-form {
//           padding: 24px;
//         }

//         .form-row {
//           margin-bottom: 20px;
//         }

//         .form-row label {
//           display: block;
//           margin-bottom: 8px;
//           font-size: 12px;
//           font-weight: 500;
//           color: var(--text-primary);
//         }

//         .input-with-icon {
//           position: relative;
//         }

//         .currency-symbol {
//           position: absolute;
//           left: 12px;
//           top: 50%;
//           transform: translateY(-50%);
//           color: var(--text-secondary);
//           font-weight: 500;
//         }

//         #edit-car-form input[type="text"] {
//           width: 100%;
//           padding: 10px 10px 10px 32px;
//           border: 1px solid var(--border-color);
//           border-radius: var(--border-radius);
//           font-size: 14px;
//           transition: all var(--transition-speed);
//         }

//         #edit-car-form input[type="text"]:focus {
//           outline: none;
//           border-color: var(--primary-color);
//           box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
//         }

//         .toggle-container {
//           display: flex;
//           align-items: center;
//           gap: 12px;
//         }

//         .toggle-switch {
//           position: relative;
//           display: inline-block;
//           width: 40px;
//           height: 22px;
//         }

//         .toggle-switch input {
//           opacity: 0;
//           width: 0;
//           height: 0;
//         }

//         .slider {
//           position: absolute;
//           cursor: pointer;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: #ccc;
//           transition: .4s;
//           border-radius: 34px;
//         }

//         .slider:before {
//           position: absolute;
//           content: "";
//           height: 14px;
//           width: 14px;
//           left: 3px;
//           bottom: 4px;
//           background-color: white;
//           transition: .4s;
//           border-radius: 50%;
//         }

//         input:checked + .slider {
//           background-color: var(--secondary-color);
//         }

//         input:checked + .slider:before {
//           transform: translateX(20px);
//         }

//         .toggle-label {
//           font-size: 12px;
//           font-weight: 500;
//         }

//         .date-inputs {
//           margin-bottom: 10px;
//         }

//         .date-range-container {
//           display: flex;
//           gap: 16px;
//         }

//         .date-input-group {
//           flex: 1;
//         }

//         .date-input-group label {
//           font-size: 11px;
//           color: var(--text-secondary);
//           margin-bottom: 6px;
//           display: block;
//         }

//         #edit-car-form input[type="date"] {
//           width: 100%;
//           padding: 10px;
//           border: 1px solid var(--border-color);
//           border-radius: var(--border-radius);
//           font-size: 12px;
//           transition: all var(--transition-speed);
//           font-family: inherit;
//         }

//         #edit-car-form input[type="date"]:focus {
//           outline: none;
//           border-color: var(--primary-color);
//           box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
//         }

//         .modal-footer {
//           display: flex;
//           justify-content: flex-end;
//           gap: 12px;
//           padding: 20px 24px;
//           border-top: 1px solid var(--border-color);
//         }

//         #modal-ok-button, #modal-cancel-button {
//           padding: 10px 16px;
//           border-radius: var(--border-radius);
//           font-size: 12px;
//           font-weight: 500;
//           cursor: pointer;
//           transition: all var(--transition-speed);
//         }

//         #modal-ok-button {
//           background-color: #ee373b;
//           color: white;
//           border: none;
//         }

//         #modal-ok-button:hover {
//           background-color: #27ae60;
//           box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
//         }

//         #modal-cancel-button {
//           background-color: white;
//           color: var(--text-primary);
//           border: 1px solid var(--border-color);
//         }

//         #modal-cancel-button:hover {
//           background-color: var(--bg-secondary);
//           border-color: var(--text-secondary);
//         }

//         .carousel-container {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//         }

//         /* Responsive adjustments */
//         @media (max-width: 768px) {
//           .filters-container {
//             flex-direction: column;
//           }

//           .search-container, .price-filter {
//             width: 100%;
//             min-width: 100%;
//           }

//           #search-input {
//             width: 100%;
//           }

//           #car-table {
//             display: none;
//           }

//           .pagination-controls {
//             display: none;
//           }

//           .mobile-pagination {
//             display: flex;
//           }

//           .cars-grid {
//             grid-template-columns: 1fr;
//           }
//         }

//         @media (min-width: 769px) {
//           .cars-grid {
//             display: none;
//           }

//           .mobile-pagination {
//             display: none;
//           }
//         }

//         @media (max-width: 480px) {
//           .car-management-container {
//             padding: 10px;
//           }
//           .page-header h1 {
//             font-size: 20px;
//           }
//           .edit-button-disabled, .edit-button-enabled {
//             padding: 6px 10px;
//             font-size: 12px;
//           }
//           #modal-content, #image-modal-content {
//             width: 100%;
//             border-radius: 0;
//             height: 100%;
//             display: flex;
//             flex-direction: column;
//           }
//           .modal-header {
//             padding: 16px;
//           }
//           .vehicle-summary {
//             padding: 16px;
//           }
//           #edit-car-form {
//             padding: 16px;
//             flex: 1;
//             overflow-y: auto;
//           }
//           .modal-footer {
//             padding: 16px;
//           }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default CarTable;

//=======================================

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import InformationModal from "../components/InformationModal";
import { IoIosImages } from "react-icons/io";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const DualRangeSlider = ({
  min = 0,
  max = 1000,
  defaultFromValue = 0,
  defaultToValue = 1000,
  onChange = () => {},
}) => {
  const [fromValue, setFromValue] = useState(defaultFromValue);
  const [toValue, setToValue] = useState(defaultToValue);
  const [activeDragger, setActiveDragger] = useState(null);
  const rangeRef = useRef(null);
  const containerRef = useRef(null);

  const getPercent = (value) => ((value - min) / (max - min)) * 100;

  useEffect(() => {
    if (rangeRef.current) {
      const fromPercent = getPercent(fromValue);
      const toPercent = getPercent(toValue);
      rangeRef.current.style.left = `${fromPercent}%`;
      rangeRef.current.style.width = `${toPercent - fromPercent}%`;
    }
    onChange({ from: fromValue, to: toValue });
  }, [fromValue, toValue, min, max]);

  useEffect(() => {
    const handlePointerMove = (e) => {
      if (!activeDragger || !containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const position = (e.clientX - rect.left) / rect.width;
      const newValue = Math.round(position * (max - min) + min);
      if (activeDragger === "from") {
        setFromValue(Math.max(min, Math.min(toValue, newValue)));
      } else if (activeDragger === "to") {
        setToValue(Math.min(max, Math.max(fromValue, newValue)));
      }
    };
    const handlePointerUp = () => {
      setActiveDragger(null);
    };
    if (activeDragger) {
      document.addEventListener("pointermove", handlePointerMove);
      document.addEventListener("pointerup", handlePointerUp);
    }
    return () => {
      document.removeEventListener("pointermove", handlePointerMove);
      document.removeEventListener("pointerup", handlePointerUp);
    };
  }, [activeDragger, min, max, fromValue, toValue]);

  return (
    <>
      <div className="dual-range-slider">
        <div className="slider-container" ref={containerRef}>
          <div className="slider-track">
            <div ref={rangeRef} className="slider-range" />
          </div>
          <div
            className="slider-dragger"
            style={{ left: `${getPercent(fromValue)}%` }}
            onPointerDown={() => setActiveDragger("from")}
          >
            <div className="slider-value">{fromValue}</div>
          </div>
          <div
            className="slider-dragger"
            style={{ left: `${getPercent(toValue)}%` }}
            onPointerDown={() => setActiveDragger("to")}
          >
            <div className="slider-value">{toValue}</div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .dual-range-slider {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .slider-container {
          position: relative;
          height: 48px;
          width: 100%;
          touch-action: none;
        }
        .slider-track {
          position: absolute;
          top: 24px;
          height: 4px;
          width: 100%;
          background-color: #d1d5db;
          border-radius: 9999px;
        }
        .slider-range {
          position: absolute;
          height: 100%;
          background-color: #ee373b;
          border-radius: 9999px;
        }
        .slider-dragger {
          position: absolute;
          top: 20px;
          width: 16px;
          height: 16px;
          background-color: #ee373b;
          border: 2px solid #ee373b;
          border-radius: 50%;
          cursor: pointer;
          transform: translateX(-50%);
          touch-action: none;
        }
        .slider-value {
          position: absolute;
          top: -32px;
          left: 50%;
          font-weight: bold;
          transform: translateX(-50%);
          font-size: 1rem;
          color: #4b5563;
        }
      `}</style>
    </>
  );
};

const CustomCarousel = ({ images, onSelectImage }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const goToPrevious = () => {
    const isFirstImage = currentIndex === 0;
    const newIndex = isFirstImage ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(newIndex);
  };

  const goToNext = () => {
    const isLastImage = currentIndex === images.length - 1;
    const newIndex = isLastImage ? 0 : currentIndex + 1;
    setCurrentIndex(newIndex);
  };

  useEffect(() => {
    if (images.length > 0) {
      setSelectedImage(images[currentIndex]);
      if (onSelectImage) onSelectImage(images[currentIndex]);
    }
  }, [currentIndex, images]);

  return (
    <div className="custom-carousel-container">
      <div className="carousel-main-image">
        <button onClick={goToPrevious} className="carousel-button">
          <IoIosArrowBack />
        </button>
        {selectedImage && (
          <img
            src={selectedImage}
            alt={`Car view ${currentIndex + 1}`}
            className="carousel-img-car"
          />
        )}
        <button onClick={goToNext} className="carousel-button">
          <IoIosArrowForward />
        </button>
      </div>
      <div className="carousel-thumbnails">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            alt={`Thumbnail ${index + 1}`}
            className={`thumbnail ${index === currentIndex ? "active" : ""}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
      <style jsx>{`
        .custom-carousel-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
          width: 100%;
        }
        .carousel-main-image {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          height: 60vh;
          width: 100%;
        }
        .carousel-main-image img {
          max-height: 100%;
          max-width: 100%;
          object-fit: contain;
        }
        .carousel-button {
          position: absolute;
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          color: #ee373b;
          z-index: 10;
        }
        .carousel-button:first-child {
          left: 10px;
        }
        .carousel-button:last-child {
          right: 10px;
        }
        .carousel-thumbnails {
          display: flex;
          gap: 10px;
          overflow-x: auto;
          padding: 10px 0;
          width: 100%;
        }
        .thumbnail {
          height: 60px;
          width: 80px;
          object-fit: cover;
          cursor: pointer;
          border: 2px solid transparent;
        }
        .thumbnail.active {
          border-color: #ee373b;
        }
        @media (max-width: 768px) {
          .carousel-main-image {
            height: 40vh;
          }
          .thumbnail {
            height: 50px;
            width: 60px;
          }
        }
      `}</style>
    </div>
  );
};

// const ImageModal = ({ isOpen, onClose, images, registrationNo, sellerId, onUpdate }) => {
//   const [activeTab, setActiveTab] = useState("preview");
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [newImages, setNewImages] = useState([]);
//   const [zipFile, setZipFile] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const fileInputRef = useRef(null);
//   const navigate = useNavigate();

//   const handleSelectImage = (image, e) => {
//     e.stopPropagation();
//     setSelectedImages((prev) =>
//       prev.includes(image) ? prev.filter((img) => img !== image) : [...prev, image]
//     );
//   };

//   const handleDeleteImages = async () => {
//     setIsLoading(true);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/${registrationNo}/delete-images?sellerId=${sellerId}`,
//         {
//           method: "DELETE",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(selectedImages),
//           credentials: "include",
//         }
//       );
//       if (response.ok) {
//         const result = await response.json();
//         onUpdate(result.images);
//         setSelectedImages([]);
//       }
//     } catch (error) {
//       console.error("Error deleting images:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleAddImages = async () => {
//     if (newImages.length === 0) return;
//     setIsLoading(true);
//     const formData = new FormData();
//     newImages.forEach((image) => formData.append("images", image));
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/${registrationNo}/add-images?sellerId=${sellerId}`,
//         {
//           method: "POST",
//           body: formData,
//           credentials: "include",
//         }
//       );
//       if (response.ok) {
//         const result = await response.json();
//         onUpdate(result.images);
//         setNewImages([]);
//         if (fileInputRef.current) fileInputRef.current.value = "";
//       }
//     } catch (error) {
//       console.error("Error adding images:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleZipFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setZipFile(file);
//     }
//   };

//   const handleReplaceImages = async () => {
//     if (!zipFile) return;
//     setIsLoading(true);
//     const formData = new FormData();
//     formData.append("zipFile", zipFile);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/${registrationNo}/replace-images?sellerId=${sellerId}`,
//         {
//           method: "POST",
//           body: formData,
//           credentials: "include",
//         }
//       );
//       if (response.ok) {
//         const result = await response.json();
//         onUpdate(result.images);
//         setZipFile(null);
//         document.getElementById("zipFileInput").value = "";
//       } else {
//         alert("Failed to replace images.");
//       }
//     } catch (error) {
//       console.error("Error replacing images:", error);
//       alert("An error occurred while replacing images.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     isOpen && (
//       <div className="image-modal-overlay" onClick={onClose}>
//         <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
//           <div className="modal-header">
//             <h2>Manage Car Images</h2>
//             <button className="close-button" onClick={onClose}>
//               ×
//             </button>
//           </div>
//           <div className="modal-tabs">
//             <button
//               className={`tab-button ${activeTab === "preview" ? "active" : ""}`}
//               onClick={() => setActiveTab("preview")}
//             >
//               Preview
//             </button>
//             <button
//               className={`tab-button ${activeTab === "manage" ? "active" : ""}`}
//               onClick={() => setActiveTab("manage")}
//             >
//               Manage
//             </button>
//             <button
//               className={`tab-button ${activeTab === "add" ? "active" : ""}`}
//               onClick={() => setActiveTab("add")}
//             >
//               Add
//             </button>
//             <button
//               className={`tab-button ${activeTab === "replace" ? "active" : ""}`}
//               onClick={() => setActiveTab("replace")}
//             >
//               Replace
//             </button>
//           </div>
//           <div className="modal-body">
//             {activeTab === "preview" && (
//               <div className="preview-container">
//                 <CustomCarousel images={images} />
//               </div>
//             )}
//             {activeTab === "manage" && (
//               <div className="manage-tab">
//                 <div className="image-grid">
//                   {images.map((image, index) => (
//                     <div
//                       key={index}
//                       className={`image-item ${selectedImages.includes(image) ? "selected" : ""}`}
//                       onClick={(e) => handleSelectImage(image, e)}
//                     >
//                       <img src={image} alt={`Car ${index + 1}`} />
//                       <div className="image-checkbox">
//                         <input
//                           type="checkbox"
//                           checked={selectedImages.includes(image)}
//                           onChange={(e) => handleSelectImage(image, e)}
//                           onClick={(e) => e.stopPropagation()}
//                         />
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//                 <div className="manage-actions">
//                   <button
//                     className="delete-button"
//                     onClick={handleDeleteImages}
//                     disabled={selectedImages.length === 0 || isLoading}
//                   >
//                     {isLoading ? "Deleting..." : `Delete Selected (${selectedImages.length})`}
//                   </button>
//                 </div>
//               </div>
//             )}
//             {activeTab === "add" && (
//               <div className="add-tab">
//                 <div className="file-upload">
//                   <input
//                     type="file"
//                     ref={fileInputRef}
//                     multiple
//                     onChange={(e) => setNewImages([...e.target.files])}
//                     accept="image/*"
//                   />
//                   <button
//                     className="add-button"
//                     onClick={handleAddImages}
//                     disabled={newImages.length === 0 || isLoading}
//                   >
//                     {isLoading ? "Adding..." : `Add Images (${newImages.length})`}
//                   </button>
//                 </div>
//               </div>
//             )}
//             {activeTab === "replace" && (
//               <div className="replace-tab">
//                 <p>Upload a ZIP file to replace all images:</p>
//                 <div className="replace-actions">
//                   <input
//                     type="file"
//                     accept=".zip"
//                     id="zipFileInput"
//                     style={{ display: "none" }}
//                     onChange={handleZipFileChange}
//                   />
//                   <label htmlFor="zipFileInput" className="choose-file-button">
//                     Choose ZIP File
//                   </label>
//                   {zipFile && <span className="file-name">{zipFile.name}</span>}
//                 </div>
//                 <button
//                   className="replace-button"
//                   onClick={handleReplaceImages}
//                   disabled={!zipFile || isLoading}
//                 >
//                   {isLoading ? "Replacing..." : "Replace All Images"}
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//         <style jsx>{`
//           .image-modal-overlay {
//             position: fixed;
//             top: 0;
//             left: 0;
//             width: 100%;
//             height: 100%;
//             background: rgba(0, 0, 0, 0.8);
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             z-index: 1000;
//             overflow: hidden;
//           }
//           .image-modal-content {
//             background: white;
//             border-radius: 10px;
//             border: 3px solid #ee373b;
//             width: 90%;
//             max-width: 800px;
//             height: 80vh;
//             display: flex;
//             flex-direction: column;
//             position: relative;
//             overflow: hidden;
//             margin-top: 7vh;
//           }
//           .modal-header {
//             background-color: #ee373b;
//             color: white;
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             padding: 20px 20px 10px 20px;
//             flex-shrink: 0;
//           }
//           .modal-header h2 {
//             color: white;
//             margin: 0;
//             font-size: 20px;
//           }
//           .close-button {
//             background: none;
//             border: none;
//             border-radius: 20px;
//             font-size: 32px;
//             cursor: pointer;
//             line-height: 0.8;
//             color: white;
//           }
//           .close-button:hover {
//             background: white;
//             color: #ee373b;
//           }
//           .modal-tabs {
//             display: flex;
//             padding: 0 20px;
//             border-bottom: 1px solid #eee;
//             flex-shrink: 0;
//             background-color: #f8f9fa;
//           }
//           .tab-button {
//             padding: 10px 20px;
//             background: none;
//             border: none;
//             cursor: pointer;
//             font-size: 16px;
//             border-bottom: 3px solid transparent;
//             transition: all 0.3s;
//           }
//           .tab-button.active {
//             border-bottom-color: #ee373b;
//             color: #ee373b;
//             font-weight: bold;
//           }
//           .modal-body {
//             padding: 20px;
//             overflow-y: auto;
//             scrollbar-color: #ee373b white;
//             flex: 1;
//             min-height: 0;
//             background-color: white;
//           }
//           .preview-container {
//             height: 100%;
//           }
//           .image-grid {
//             display: grid;
//             grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
//             gap: 10px;
//             margin-bottom: 20px;
//           }
//           .image-item {
//             position: relative;
//             cursor: pointer;
//             border: 2px solid transparent;
//             border-radius: 5px;
//             transition: border-color 0.2s;
//           }
//           .image-item.selected {
//             border-color: #ee373b;
//           }
//           .image-item:hover {
//             border-color: #ee373b;
//             opacity: 0.9;
//           }
//           .image-item img {
//             width: 100%;
//             height: 100px;
//             object-fit: cover;
//             border-radius: 5px;
//             display: block;
//           }
//           .image-checkbox {
//             position: absolute;
//             top: 5px;
//             right: 5px;
//             background: rgba(255, 255, 255, 0.9);
//             border-radius: 50%;
//             width: 24px;
//             height: 24px;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//             box-shadow: 0 2px 4px rgba(0,0,0,0.2);
//           }
//           .image-checkbox input {
//             width: 16px;
//             height: 16px;
//             cursor: pointer;
//           }
//           .manage-actions {
//             display: flex;
//             justify-content: space-between;
//             align-items: center;
//             gap: 10px;
//             margin-top: 10px;
//             flex-wrap: wrap;
//           }
//           .delete-button, .add-button, .replace-button {
//             padding: 10px 20px;
//             border: none;
//             border-radius: 5px;
//             cursor: pointer;
//             font-weight: bold;
//             font-size: 14px;
//             transition: opacity 0.2s;
//           }
//           .delete-button:disabled, .add-button:disabled, .replace-button:disabled {
//             opacity: 0.5;
//             cursor: not-allowed;
//           }
//           .delete-button {
//             background: #ff4444;
//             color: white;
//           }
//           .delete-button:hover:not(:disabled) {
//             background: #cc0000;
//           }
//           .add-button {
//             background: transparent;
//             color: #ee373b;
//             border: 1px solid #ee373b;
//           }
//           .add-button:hover:not(:disabled) {
//             background: #ee373b;
//             color: white;
//           }
//           .replace-button {
//             background: #ee373b;
//             color: white;
//             margin-top: 15px;
//             width: 100%;
//           }
//           .replace-button:hover:not(:disabled) {
//             background: #d32f2f;
//           }
//           .file-upload {
//             display: flex;
//             align-items: center;
//             gap: 10px;
//           }
//           .file-upload input[type="file"] {
//             font-size: 14px;
//           }
//           .replace-tab {
//             padding: 20px;
//           }
//           .replace-tab p {
//             margin-bottom: 15px;
//             font-size: 16px;
//           }
//           .replace-actions {
//             display: flex;
//             align-items: center;
//             gap: 15px;
//             margin-bottom: 15px;
//             flex-wrap: wrap;
//           }
//           .choose-file-button {
//             padding: 10px 20px;
//             background: transparent;
//             color: #ee373b;
//             border: 1px solid #ee373b;
//             border-radius: 5px;
//             cursor: pointer;
//             font-weight: bold;
//             transition: background 0.2s;
//           }
//           .choose-file-button:hover {
//             background: #ee373b;
//             color: white;
//           }
//           .file-name {
//             font-size: 14px;
//             color: #666;
//             max-width: 300px;
//             overflow: hidden;
//             text-overflow: ellipsis;
//             white-space: nowrap;
//           }
//           .add-tab {
//             padding: 20px;
//           }
//           .add-tab .file-upload {
//             display: flex;
//             align-items: center;
//             gap: 10px;
//             margin-bottom: 15px;
//             flex-wrap: wrap;
//           }
//           .add-tab .add-button {
//             padding: 10px 20px;
//             background: transparent;
//             color: #ee373b;
//             border: 1px solid #ee373b;
//             border-radius: 5px;
//             cursor: pointer;
//             font-weight: bold;
//             transition: background 0.2s;
//           }
//           .add-tab .add-button:hover:not(:disabled) {
//             background: #ee373b;
//             color: white;
//           }
//           @media (max-width: 768px) {
//             .image-modal-content {
//               width: 95%;
//               max-height: 90vh;
//             }
//             .modal-header {
//               padding: 15px;
//             }
//             .modal-body {
//               padding: 15px;
//             }
//             .image-grid {
//               grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
//             }
//             .manage-actions {
//               flex-direction: column;
//               align-items: stretch;
//             }
//             .file-upload {
//               flex-direction: column;
//               align-items: stretch;
//             }
//           }
//         `}</style>
//       </div>
//     )
//   );
// };


const ImageModal = ({ isOpen, onClose, images, registrationNo, sellerId, onUpdate }) => {
  const [activeTab, setActiveTab] = useState("preview");
  const [selectedImages, setSelectedImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [zipFile, setZipFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();

  const handleSelectImage = (image, e) => {
    e.stopPropagation();
    setSelectedImages((prev) =>
      prev.includes(image) ? prev.filter((img) => img !== image) : [...prev, image]
    );
  };

  const handleDeleteImages = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/${registrationNo}/delete-images?sellerId=${sellerId}`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(selectedImages),
          credentials: "include",
        }
      );
      if (response.ok) {
        const result = await response.json();
        onUpdate(result.images, registrationNo);
        setSelectedImages([]);
      }
    } catch (error) {
      console.error("Error deleting images:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddImages = async () => {
    if (newImages.length === 0) return;
    setIsLoading(true);
    const formData = new FormData();
    newImages.forEach((image) => formData.append("images", image));
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/${registrationNo}/add-images?sellerId=${sellerId}`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        }
      );
      if (response.ok) {
        const result = await response.json();
        onUpdate(result.images, registrationNo);
        setNewImages([]);
        if (fileInputRef.current) fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Error adding images:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleZipFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setZipFile(file);
    }
  };

  const handleReplaceImages = async () => {
    if (!zipFile) return;
    setIsLoading(true);
    const formData = new FormData();
    formData.append("zipFile", zipFile);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_ENDPOINT}/api/dealer/vehicles/${registrationNo}/replace-images?sellerId=${sellerId}`,
        {
          method: "POST",
          body: formData,
          credentials: "include",
        }
      );
      if (response.ok) {
        const result = await response.json();
        onUpdate(result.images, registrationNo);
        setZipFile(null);
        document.getElementById("zipFileInput").value = "";
      } else {
        alert("Failed to replace images.");
      }
    } catch (error) {
      console.error("Error replacing images:", error);
      alert("An error occurred while replacing images.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    isOpen && (
      <div className="image-modal-overlay" onClick={onClose}>
        <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h2>Manage Car Images</h2>
            <button className="close-button" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="modal-tabs">
            <button
              className={`tab-button ${activeTab === "preview" ? "active" : ""}`}
              onClick={() => setActiveTab("preview")}
            >
              Preview
            </button>
            <button
              className={`tab-button ${activeTab === "manage" ? "active" : ""}`}
              onClick={() => setActiveTab("manage")}
            >
              Delete
            </button>
            <button
              className={`tab-button ${activeTab === "add" ? "active" : ""}`}
              onClick={() => setActiveTab("add")}
            >
              Add
            </button>
            <button
              className={`tab-button ${activeTab === "replace" ? "active" : ""}`}
              onClick={() => setActiveTab("replace")}
            >
              Replace
            </button>
          </div>
          <div className="modal-body">
            {activeTab === "preview" && (
              <div className="preview-container">
                {images && images.length > 0 ? (
                  <CustomCarousel images={images} />
                ) : (
                  <div className="no-images-message">
                    <p>No images available for this vehicle.</p>
                    <p className="hint">Use the "Add" tab to upload images.</p>
                  </div>
                )}
              </div>
            )}
            {activeTab === "manage" && (
              <div className="manage-tab">
                {images && images.length > 0 ? (
                  <>
                    <div className="image-grid">
                      {images.map((image, index) => (
                        <div
                          key={index}
                          className={`image-item ${selectedImages.includes(image) ? "selected" : ""}`}
                          onClick={(e) => handleSelectImage(image, e)}
                        >
                          <img src={image} alt={`Car ${index + 1}`} />
                          <div className="image-checkbox">
                            <input
                              type="checkbox"
                              checked={selectedImages.includes(image)}
                              onChange={(e) => handleSelectImage(image, e)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="manage-actions">
                      <button
                        className="delete-button"
                        onClick={handleDeleteImages}
                        disabled={selectedImages.length === 0 || isLoading}
                      >
                        {isLoading ? "Deleting..." : `Delete Selected (${selectedImages.length})`}
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="no-images-message">
                    <p>No images available to delete.</p>
                    <p className="hint">Use the "Add" tab to upload images first.</p>
                  </div>
                )}
              </div>
            )}
            {activeTab === "add" && (
              <div className="add-tab">
                <div className="file-upload">
                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    onChange={(e) => setNewImages([...e.target.files])}
                    accept="image/*"
                  />
                  <button
                    className="add-button"
                    onClick={handleAddImages}
                    disabled={newImages.length === 0 || isLoading}
                  >
                    {isLoading ? "Adding..." : `Add Images (${newImages.length})`}
                  </button>
                </div>
              </div>
            )}
            {activeTab === "replace" && (
              <div className="replace-tab">
                <p>Upload a ZIP file to replace all images:</p>
                <div className="replace-actions">
                  <input
                    type="file"
                    accept=".zip"
                    id="zipFileInput"
                    style={{ display: "none" }}
                    onChange={handleZipFileChange}
                  />
                  <label htmlFor="zipFileInput" className="choose-file-button">
                    Choose ZIP File
                  </label>
                  {zipFile && <span className="file-name">{zipFile.name}</span>}
                </div>
                <button
                  className="replace-button"
                  onClick={handleReplaceImages}
                  disabled={!zipFile || isLoading}
                >
                  {isLoading ? "Replacing..." : "Replace All Images"}
                </button>
              </div>
            )}
          </div>
        </div>
        <style jsx>{`
          .image-modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
            overflow: hidden;
          }
          .image-modal-content {
            background: white;
            border-radius: 10px;
            border: 3px solid #ee373b;
            width: 90%;
            max-width: 800px;
            height: 80vh;
            display: flex;
            flex-direction: column;
            position: relative;
            overflow: hidden;
            margin-top: 7vh;
          }
          .modal-header {
            background-color: #ee373b;
            color: white;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px 20px 10px 20px;
            flex-shrink: 0;
          }
          .modal-header h2 {
            color: white;
            margin: 0;
            font-size: 20px;
          }
          .close-button {
            background: none;
            border: none;
            border-radius: 20px;
            font-size: 32px;
            cursor: pointer;
            line-height: 0.8;
            color: white;
          }
          .close-button:hover {
            background: white;
            color: #ee373b;
          }
          .modal-tabs {
            display: flex;
            padding: 0 20px;
            border-bottom: 1px solid #eee;
            flex-shrink: 0;
            background-color: #f8f9fa;
          }
          .tab-button {
            padding: 10px 20px;
            background: none;
            border: none;
            cursor: pointer;
            font-size: 16px;
            border-bottom: 3px solid transparent;
            transition: all 0.3s;
          }
          .tab-button.active {
            border-bottom-color: #ee373b;
            color: #ee373b;
            font-weight: bold;
          }
          .modal-body {
            padding: 20px;
            overflow-y: auto;
            scrollbar-color: #ee373b white;
            flex: 1;
            min-height: 0;
            background-color: white;
          }
          .preview-container {
            height: 100%;
          }
          .image-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
            gap: 10px;
            margin-bottom: 20px;
          }
          .image-item {
            position: relative;
            cursor: pointer;
            border: 2px solid transparent;
            border-radius: 5px;
            transition: border-color 0.2s;
          }
          .image-item.selected {
            border-color: #ee373b;
          }
          .image-item:hover {
            border-color: #ee373b;
            opacity: 0.9;
          }
          .image-item img {
            width: 100%;
            height: 100px;
            object-fit: cover;
            border-radius: 5px;
            display: block;
          }
          .image-checkbox {
            position: absolute;
            top: 5px;
            right: 5px;
            background: rgba(255, 255, 255, 0.9);
            border-radius: 50%;
            width: 24px;
            height: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
          }
          .image-checkbox input {
            width: 16px;
            height: 16px;
            cursor: pointer;
          }
          .manage-actions {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
            margin-top: 10px;
            flex-wrap: wrap;
          }
          .delete-button, .add-button, .replace-button {
            padding: 10px 20px;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            font-weight: bold;
            font-size: 14px;
            transition: opacity 0.2s;
          }
          .delete-button:disabled, .add-button:disabled, .replace-button:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
          .delete-button {
            background: #ff4444;
            color: white;
          }
          .delete-button:hover:not(:disabled) {
            background: #cc0000;
          }
          .add-button {
            background: transparent;
            color: #ee373b;
            border: 1px solid #ee373b;
          }
          .add-button:hover:not(:disabled) {
            background: #ee373b;
            color: white;
          }
          .replace-button {
            background: #ee373b;
            color: white;
            margin-top: 15px;
            width: 100%;
          }
          .replace-button:hover:not(:disabled) {
            background: #d32f2f;
          }
          .file-upload {
            display: flex;
            align-items: center;
            gap: 10px;
          }
          .file-upload input[type="file"] {
            font-size: 14px;
          }
          .replace-tab {
            padding: 20px;
          }
          .replace-tab p {
            margin-bottom: 15px;
            font-size: 16px;
          }
          .replace-actions {
            display: flex;
            align-items: center;
            gap: 15px;
            margin-bottom: 15px;
            flex-wrap: wrap;
          }
          .choose-file-button {
            padding: 10px 20px;
            background: transparent;
            color: #ee373b;
            border: 1px solid #ee373b;
            border-radius: 5px;
            cursor: pointer;
            font-weight: bold;
            transition: background 0.2s;
          }
          .choose-file-button:hover {
            background: #ee373b;
            color: white;
          }
          .file-name {
            font-size: 14px;
            color: #666;
            max-width: 300px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .add-tab {
            padding: 20px;
          }
          .add-tab .file-upload {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-bottom: 15px;
            flex-wrap: wrap;
          }
          .add-tab .add-button {
            padding: 10px 20px;
            background: transparent;
            color: #ee373b;
            border: 1px solid #ee373b;
            border-radius: 5px;
            cursor: pointer;
            font-weight: bold;
            transition: background 0.2s;
          }
          .add-tab .add-button:hover:not(:disabled) {
            background: #ee373b;
            color: white;
          }
          @media (max-width: 768px) {
            .image-modal-content {
              width: 95%;
              max-height: 90vh;
            }
            .modal-header {
              padding: 15px;
            }
            .modal-body {
              padding: 15px;
            }
            .image-grid {
              grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
            }
            .manage-actions {
              flex-direction: column;
              align-items: stretch;
            }
            .file-upload {
              flex-direction: column;
              align-items: stretch;
            }
          }
          .no-images-message {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 100%;
            min-height: 300px;
            text-align: center;
            color: #666;
          }
          .no-images-message p {
            margin: 10px 0;
            font-size: 18px;
          }
          .no-images-message .hint {
            font-size: 14px;
            color: #999;
            font-style: italic;
          }
        `}</style>
      </div>
    )
  );
};

const CarCard = ({ car, showModal, showImageModal, formatCurrency, formatDate }) => {
  return (
    <div className="car-card">
      <div className="car-card-header">
        <h3>{car.make} {car.model} ({car.year})</h3>
        <div className="car-badges">
          <span className={`status-badge ${car.allowed === 'y' ? 'status-active' : 'status-inactive'}`}>
            {car.allowed === 'y' ? 'Active' : 'Inactive'}
          </span>
          <span className={`event-badge ${car.usedInEvent ? 'in-event' : 'not-in-event'}`}>
            {car.usedInEvent ? 'In Event' : 'Available'}
          </span>
        </div>
      </div>
      <div className="car-card-body">
        <div className="car-card-row">
          <span className="car-card-label">Reg. Number:</span>
          <span className="car-card-value">{car.registrationNo}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Price:</span>
          <span className="car-card-value">{formatCurrency(car.startPrice)}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Insurance:</span>
          <span className="car-card-value">{car.insurance}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">RC Status:</span>
          <span className="car-card-value">{car.rcRequired}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Color:</span>
          <span className="car-card-value">{car.color}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Odometer:</span>
          <span className="car-card-value">{car.odometer}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Fuel:</span>
          <span className="car-card-value">{car.fuel}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Transmission:</span>
          <span className="car-card-value">{car.transmission}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Available From:</span>
          <span className="car-card-value">{formatDate(car.availableStartDateAndTime)}</span>
        </div>
        <div className="car-card-row">
          <span className="car-card-label">Available To:</span>
          <span className="car-card-value">{formatDate(car.availableEndDateAndTime)}</span>
        </div>
      </div>
      <div className="car-card-footer">
        <button onClick={() => showImageModal(car.images || [], car.registrationNo)} className="view-images-button">
          {car.images && car.images.length > 0 ? "View Images" : "Add Images"}
        </button>
        <button disabled={car.usedInEvent} onClick={() => showModal(car)} className={`edit-button-${car.usedInEvent ? "disabled" : "enabled"}`}>
          Edit
        </button>
      </div>
      <style jsx>{`
        .car-card {
          border: 1px solid var(--border-color, #e5e7eb);
          border-radius: var(--border-radius, 8px);
          padding: 12px 16px;
          background-color: var(--bg-primary, white);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          margin-bottom: 16px;
          transition: box-shadow 0.2s ease;
        }
        .car-card:hover {
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
        }
        .car-card-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 12px;
          gap: 12px;
        }
        .car-card-header h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: var(--text-primary, #111827);
          line-height: 1.3;
          word-wrap: break-word;
          flex: 1;
          min-width: 0;
        }
        .car-badges {
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex-shrink: 0;
        }
        .status-badge, .event-badge {
          font-size: 10px;
          font-weight: 500;
          padding: 3px 8px;
          border-radius: 12px;
          text-align: center;
          white-space: nowrap;
        }
        .status-active {
          background: #dcfce7;
          color: #166534;
        }
        .status-inactive {
          background: #fef2f2;
          color: #dc2626;
        }
        .in-event {
          background: #fef3c7;
          color: #d97706;
        }
        .not-in-event {
          background: #e0f2fe;
          color: #0369a1;
        }
        .car-card-body {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 6px 12px;
        }
        @media (max-width: 768px) {
          .car-card-body {
            grid-template-columns: repeat(2, 1fr);
            gap: 6px 8px;
          }
        }
        @media (max-width: 480px) {
          .car-card-body {
            grid-template-columns: 1fr;
            gap: 4px;
          }
          .car-card-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }
          .car-badges {
            flex-direction: row;
            gap: 6px;
          }
        }
        .car-card-row {
          display: flex;
          flex-direction: column;
          gap: 2px;
          min-width: 0;
        }
        .car-card-label {
          font-size: 10px;
          color: var(--text-secondary, #6b7280);
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.025em;
        }
        .car-card-value {
          font-size: 13px;
          color: var(--text-primary, #111827);
          font-weight: 500;
          word-wrap: break-word;
          line-height: 1.3;
        }
        .car-card-footer {
          display: flex;
          justify-content: flex-end;
          gap: 8px;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid var(--border-color, #f3f4f6);
        }
        .view-images-button {
          background-color: var(--bg-secondary, #f3f4f6);
          color: var(--text-primary, #374151);
          border: 1px solid var(--border-color, #d1d5db);
          border-radius: var(--border-radius, 6px);
          padding: 6px 12px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all var(--transition-speed, 0.2s) ease;
          white-space: nowrap;
        }
        .view-images-button:hover {
          background-color: var(--bg-primary, #e5e7eb);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
        .edit-button-enabled {
          background-color: #3b82f6;
          color: white;
          border: 1px solid #3b82f6;
          border-radius: var(--border-radius, 6px);
          padding: 6px 12px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all var(--transition-speed, 0.2s) ease;
          white-space: nowrap;
        }
        .edit-button-enabled:hover {
          background-color: #2563eb;
          border-color: #2563eb;
        }
        .edit-button-disabled {
          background-color: #f9fafb;
          color: #9ca3af;
          border: 1px solid #e5e7eb;
          border-radius: var(--border-radius, 6px);
          padding: 6px 12px;
          font-size: 12px;
          font-weight: 500;
          cursor: not-allowed;
          white-space: nowrap;
        }
        @media (max-width: 480px) {
          .car-card-footer {
            flex-direction: column;
            gap: 6px;
          }
          .view-images-button,
          .edit-button-enabled,
          .edit-button-disabled {
            width: 100%;
            text-align: center;
          }
        }
      `}</style>
    </div>
  );
};

const SortIndicator = ({ sortConfig }) => {
  if (!sortConfig.key) return null;
  const keyToLabel = {
    'registrationNo': 'Reg. Number',
    'make': 'Car Details',
    'startPrice': 'Base Price',
    'insurance': 'Insurance Status',
    'rcRequired': 'RC Status',
    'color': 'Color',
    'odometer': 'Odometer',
    'fuel': 'Fuel',
    'transmission': 'Transmission',
    'allowed': 'Live Availability',
    'availableStartDateAndTime': 'Available From',
    'availableEndDateAndTime': 'Available To',
    'usedInEvent': 'In Event'
  };
  const label = keyToLabel[sortConfig.key] || sortConfig.key;
  const direction = sortConfig.direction === 'ascending' ? '↑' : '↓';
  return (
    <div className="sort-indicator-mobile">
      Sorted by: {label} {direction}
    </div>
  );
};

const CarTable = () => {
  const [cars, setCars] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const [priceRange, setPriceRange] = useState([0, 1000000]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedCarImages, setSelectedCarImages] = useState([]);
  const [selectedCarRegistrationNo, setSelectedCarRegistrationNo] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);
  const dateRef1 = useRef();
  const dateRef2 = useRef();
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    fetchCars();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const fetchCars = async () => {
    const sellerId = Cookies.get("adminSellerId");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/dealer/cars-manage/${sellerId}`, {
        credentials: "include",
        headers: {
          "X-Full-URL": window.location.href,
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setCars(data);
    } catch (error) {
      console.error('Error fetching cars:', error);
    }
  };

  const showModal = (car) => {
    setSelectedCar(car);
    setIsModalVisible(true);
  };

  const handleImageUpdate = (updatedImages, registrationNo) => {
    setCars((prevCars) =>
      prevCars.map((car) =>
        car.registrationNo === registrationNo
          ? { ...car, images: updatedImages }
          : car
      )
    );
    setSelectedCarImages(updatedImages);
  };

  const handleOk = async () => {
    try {
      const formattedSelectedCar = {
        ...selectedCar,
        availableStartDateAndTime: formatDateTime(selectedCar.availableStartDateAndTime),
        availableEndDateAndTime: formatDateTime(selectedCar.availableEndDateAndTime),
      };
      const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/dealer/cars-manage/update`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          "X-Full-URL": window.location.href,
        },
        body: JSON.stringify(formattedSelectedCar),
        credentials: "include"
      });
      if (response.ok) {
        setModalMessage("Car Details Updated");
        setIsModalOpen(true);
      }
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setIsModalVisible(false);
      fetchCars();
    } catch (error) {
      console.error('Error updating car details:', error);
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleInputChange = (e, field) => {
    setSelectedCar({
      ...selectedCar,
      [field]: e.target.value
    });
  };

  const handleToggleChange = (e) => {
    setSelectedCar({
      ...selectedCar,
      allowed: e.target.checked ? 'y' : 'n'
    });
  };

  const handleDateChange = (dates) => {
    setSelectedCar({
      ...selectedCar,
      availableStartDateAndTime: dates[0],
      availableEndDateAndTime: dates[1],
    });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const handlePriceRangeChange = (range) => {
    setPriceRange([range.from, range.to]);
  };

  // const showImageModal = (images, registrationNo) => {
  //   setSelectedCarImages(images);
  //   setSelectedCarRegistrationNo(registrationNo);
  //   setIsImageModalOpen(true);
  // };

  // const closeImageModal = () => {
  //   setIsImageModalOpen(false);
  // };

  const showImageModal = (images, registrationNo) => {
    setSelectedCarImages(images);
    setSelectedCarRegistrationNo(registrationNo);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  // const handleImageUpdate = (newImages) => {
  //   setSelectedCarImages(newImages);
  // };


  const handleFocusFirst = () => {
    if (dateRef1.current?.showPicker) {
      dateRef1.current.showPicker();
    }
  };

  const handleFocusSecond = () => {
    if (dateRef2.current?.showPicker) {
      dateRef2.current.showPicker();
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0
    }).format(value);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const minPrice = Math.min(...cars.map(car => car.startPrice), 0);
  const maxPrice = Math.max(...cars.map(car => car.startPrice), 1000000);

  const filteredCars = cars
    .filter(car => {
      const searchTermLower = searchTerm.toLowerCase();
      return Object.values(car).some(value =>
        String(value).toLowerCase().includes(searchTermLower)
      );
    })
    .filter(car => car.startPrice >= priceRange[0] && car.startPrice <= priceRange[1])
    .sort((a, b) => {
      if (!sortConfig.key) return 0;
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });

  return (
    <div className="car-management-container">
      <InformationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        message={modalMessage}
      />
      <div className="page-header">
        <h1>Vehicle Inventory Management</h1>
      </div>
      <div className="filters-container">
        <div className="search-container">
          <input
            type="text"
            placeholder="Search vehicles..."
            value={searchTerm}
            onChange={handleSearch}
            id="search-input"
          />
        </div>
        <div className="price-filter">
          <label htmlFor="price-range-input">Price Range: {formatCurrency(priceRange[0])} - {formatCurrency(priceRange[1])}</label>
          <DualRangeSlider
            min={minPrice}
            max={maxPrice}
            defaultFromValue={minPrice}
            defaultToValue={maxPrice}
            onChange={handlePriceRangeChange}
          />
        </div>
      </div>
      <div className="content-container">
        {!isMobileView && (
          <div className="table-scroll-container">
            <table id="car-table">
              <thead>
                <tr>
                  <th onClick={() => handleSort('registrationNo')}>
                    Reg. Number
                    {sortConfig.key === 'registrationNo' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('year')}>
                    Car Details
                    {sortConfig.key === 'make' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('startPrice')}>
                    Base Price
                    {sortConfig.key === 'startPrice' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('insurance')}>
                    Insurance Status
                    {sortConfig.key === 'insurance' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('rcRequired')}>
                    RC Status
                    {sortConfig.key === 'rcRequired' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('color')}>
                    Color
                    {sortConfig.key === 'color' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('odometer')}>
                    Odometer
                    {sortConfig.key === 'odometer' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('fuel')}>
                    Fuel
                    {sortConfig.key === 'fuel' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('transmission')}>
                    Transmission
                    {sortConfig.key === 'transmission' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('allowed')}>
                    Live Availability
                    {sortConfig.key === 'allowed' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('availableStartDateAndTime')}>
                    Available From
                    {sortConfig.key === 'availableStartDateAndTime' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('availableEndDateAndTime')}>
                    Available To
                    {sortConfig.key === 'availableEndDateAndTime' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th onClick={() => handleSort('usedInEvent')}>
                    In Event
                    {sortConfig.key === 'usedInEvent' && (
                      <span className="sort-indicator">{sortConfig.direction === 'ascending' ? ' ↑' : ' ↓'}</span>
                    )}
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredCars.length > 0 ? (
                  filteredCars.map((car) => (
                    <tr key={car.auctionListId}>
                      <td className="table-cell">
                        {car.registrationNo.length > 10 ? car.registrationNo.slice(0,6) : car.registrationNo}
                        <IoIosImages
                          onClick={() => showImageModal(car.images || [], car.registrationNo)}
                          style={{ cursor: 'pointer', marginLeft: '5px' }}
                        />
                      </td>
                      <td className="table-cell">{`${car.make} ${car.model} ${car.variant} - ${car.year}`}</td>
                      <td className="table-cell price-cell">{formatCurrency(car.startPrice)}</td>
                      <td className="table-cell">{car.insurance}</td>
                      <td className="table-cell">{car.rcRequired}</td>
                      <td className="table-cell">{car.color}</td>
                      <td className="table-cell">{car.odometer}</td>
                      <td className="table-cell">{car.fuel}</td>
                      <td className="table-cell">{car.transmission}</td>
                      <td className="table-cell">
                        <span className={`status-badge ${car.allowed === 'y' ? 'status-active' : 'status-inactive'}`}>
                          {car.allowed === 'y' ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td className="table-cell">{formatDate(car.availableStartDateAndTime)}</td>
                      <td className="table-cell">{formatDate(car.availableEndDateAndTime)}</td>
                      <td className="table-cell">
                        <span className={`event-badge ${car.usedInEvent ? 'in-event' : 'not-in-event'}`}>
                          {car.usedInEvent ? 'Yes' : 'No'}
                        </span>
                      </td>
                      <td className="action-cell">
                        <button disabled={car.usedInEvent} onClick={() => showModal(car)} className={`edit-button-${car.usedInEvent ? "disabled" : "enabled"}`}>
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="20" className="no-results">No vehicles match your search criteria</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
        {isMobileView && (
          <div className="cards-scroll-container">
            <SortIndicator sortConfig={sortConfig} />
            <div className="cars-grid">
              {filteredCars.length > 0 ? (
                filteredCars.map((car) => (
                  <CarCard
                    key={car.auctionListId}
                    car={car}
                    showModal={showModal}
                    showImageModal={showImageModal}
                    formatCurrency={formatCurrency}
                    formatDate={formatDate}
                  />
                ))
              ) : (
                <div className="no-results">No vehicles match your search criteria</div>
              )}
            </div>
          </div>
        )}
      </div>
      {isModalVisible && (
        <div id="modal-backdrop">
          <div id="modal-content" style={{ border: "2px solid #ee373b" }}>
            <div className="modal-header">
              <h2 id="modal-title">Edit Vehicle Details</h2>
            </div>
            <div className="vehicle-summary">
              <h3 style={{ border: "0px", paddingBottom: "0px" }}>{selectedCar?.make} {selectedCar?.model} {selectedCar?.variant} ({selectedCar?.year})</h3>
              <p className="reg-number">Registration: {selectedCar?.registrationNo}</p>
            </div>
            <form id="edit-car-form">
              <div className="form-row">
                <label id="allowed-label">
                  Listing Status:
                  <div className="toggle-container">
                    <label className="toggle-switch">
                      <input
                        type="checkbox"
                        checked={selectedCar?.allowed === 'y'}
                        onChange={handleToggleChange}
                      />
                      <span className="slider"></span>
                    </label>
                    <span className="toggle-label">{selectedCar?.allowed === 'y' ? 'Active' : 'Inactive'}</span>
                  </div>
                </label>
              </div>
              <div className="form-row date-inputs">
                <label id="available-date-label">Available Date Range:</label>
                <div className="date-range-container">
                  <div className="date-input-group">
                    <label>From:</label>
                    <input
                      type="date"
                      ref={dateRef1}
                      onClick={handleFocusFirst}
                      min={today}
                      value={selectedCar?.availableStartDateAndTime?.split('T')[0]}
                      onChange={(e) => handleInputChange(e, 'availableStartDateAndTime')}
                    />
                  </div>
                  <div className="date-input-group">
                    <label>To:</label>
                    <input
                      type="date"
                      ref={dateRef2}
                      onClick={handleFocusSecond}
                      value={selectedCar?.availableEndDateAndTime?.split('T')[0]}
                      onChange={(e) => handleInputChange(e, 'availableEndDateAndTime')}
                    />
                  </div>
                </div>
              </div>
            </form>
            <div className="modal-footer" style={{ border: "0px" }}>
              <button id="modal-cancel-button" onClick={handleCancel}>Cancel</button>
              <button id="modal-ok-button" onClick={handleOk}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
      <ImageModal
        isOpen={isImageModalOpen}
        onClose={closeImageModal}
        images={selectedCarImages}
        registrationNo={selectedCarRegistrationNo}
        sellerId={Cookies.get("adminSellerId")}
        onUpdate={handleImageUpdate}
      />
      <style jsx>{`
        :root {
          --primary-color: #3498db;
          --primary-dark: #2980b9;
          --secondary-color: #2ecc71;
          --danger-color: #e74c3c;
          --warning-color: #f39c12;
          --text-primary: #2c3e50;
          --text-secondary: #7f8c8d;
          --bg-primary: #ffffff;
          --bg-secondary: #f8f9fa;
          --border-color: #e1e4e8;
          --shadow-color: rgba(0, 0, 0, 0.1);
          --border-radius: 8px;
          --transition-speed: 0.3s;
        }
        .car-management-container {
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          color: var(--text-primary);
          background-color: white;
          box-sizing: border-box;
          border: 2px solid #ee373b;
          margin: 10px;
          border-radius: 20px;
          display: flex;
          flex-direction: column;
          height: calc(100vh - 7rem);
        }
        .page-header {
          margin-bottom: 12px;
          background-color: #ee373b;
          text-align: center;
          border-top-left-radius: 18px;
          border-top-right-radius: 18px;
          padding: 10px;
        }
        .page-header h1 {
          font-size: 24px;
          font-weight: 600;
          margin: 0;
          color: white;
        }
        .filters-container {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          margin-bottom: 12px;
          padding: 0px 10px;
          align-items: center;
        }
        .search-container {
          position: relative;
          margin-top: 3vh;
          flex: 1;
          min-width: 250px;
        }
        .search-icon {
          position: absolute;
          top: 50%;
          left: 12px;
          transform: translateY(-50%);
          color: var(--text-secondary);
          font-style: normal;
        }
        #search-input {
          width: 100%;
          padding: 8px 10px 8px 10px;
          border: 1px solid #ee373b;
          border-radius: var(--border-radius);
          font-size: 14px;
        }
        #search-input:focus {
          outline: none;
        }
        .price-filter {
          flex: 1;
          min-width: 250px;
          display: flex;
          padding: 0px 25px;
          flex-direction: column;
        }
        .price-filter label {
          font-size: 1rem;
          font-weight: bold;
          text-align: center;
          margin-bottom: 4px;
          color: #ee373b;
        }
        .content-container {
          flex: 1;
          overflow: hidden;
        }
        .table-scroll-container {
          height: 56vh;
          overflow-y: auto;
          padding: 0px 10px;
          scrollbar-color: #ee373b #ffffff;
        }
        .cars-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 16px;
          padding: 16px;
        }
        .cards-scroll-container {
          height: 65vh;
          overflow-y: auto;
        }
        #car-table {
          width: 100%;
          border-collapse: collapse;
          border: none;
          font-size: 12px;
        }
        #car-table th {
          background-color: var(--bg-secondary);
          color: var(--text-primary);
          font-weight: 600;
          text-align: left;
          padding: 3px 1px;
          font-size: 12px;
          border-bottom: 2px solid var(--border-color);
          cursor: pointer;
          white-space: nowrap;
          position: sticky;
          top: 0;
          transition: background-color var(--transition-speed);
        }
        #car-table th:hover {
          background-color: #e9ecef;
        }
        .sort-indicator {
          color: var(--primary-color);
          font-weight: bold;
        }
        #car-table td {
          padding: 3px 1px;
          border-bottom: 1px solid #ee373b;
          vertical-align: middle;
          max-width: 100px;
          font-size: 12px;
          overflow: hidden;
          text-wrap: wrap;
        }
        #car-table tr:last-child td {
          border-bottom: none;
        }
        .no-results {
          text-align: center;
          padding: 40px 0 !important;
          color: var(--text-secondary);
          font-style: italic;
        }
        .table-cell {
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .price-cell {
          font-weight: 600;
          color: var(--text-primary);
        }
        .status-badge {
          display: inline-block;
          padding: 4px 8px;
          border-radius: 30px;
          font-size: 10px;
          font-weight: 600;
          text-align: center;
        }
        .status-active {
          background-color: rgba(46, 204, 113, 0.15);
          color: #27ae60;
        }
        .status-inactive {
          background-color: rgba(231, 76, 60, 0.15);
          color: #c0392b;
        }
        .event-badge {
          display: inline-block;
          padding: 4px 8px;
          min-width: 3vw;
          border-radius: 4px;
          font-size: 10px;
          font-weight: 500;
          text-align: center;
        }
        .in-event {
          background-color: rgba(46, 204, 113, 0.15);
          color: #00b050;
          font-weight: bold;
        }
        .not-in-event {
          background-color: rgba(231, 76, 60, 0.15);
          color: #c0392b;
        }
        .action-cell {
          text-align: center;
        }
        .edit-button-enabled {
          background-color: var(--danger-color);
          color: white;
          border: 1px solid #ee373b;
          border-radius: 4px;
          padding: 6px 12px;
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color var(--transition-speed);
        }
        .edit-button-enabled:hover {
          background-color: #27ae60;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }
        .edit-button-disabled {
          background-color: white;
          cursor: not-allowed;
          color: #ee373b;
          border: 1px solid #ee373b;
          border-radius: 4px;
          padding: 6px 12px;
          font-size: 12px;
          font-weight: 500;
          transition: background-color var(--transition-speed);
        }
        .sort-indicator-mobile {
          padding: 8px 16px;
          background-color: var(--bg-secondary);
          border-radius: var(--border-radius);
          margin-bottom: 16px;
          font-size: 12px;
          color: var(--text-secondary);
          text-align: center;
        }
        #modal-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          animation: fadeIn 0.2s ease-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        #modal-content, #image-modal-content {
          background: white;
          border-radius: 12px;
          width: 90%;
          max-width: 550px;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
          animation: slideIn 0.3s ease-out;
          overflow: hidden;
          border: 2px solid #ee373b;
          min-height: 80vh;
          max-height: 80vh;
          margin-top: 10vh;
        }
        @keyframes slideIn {
          from { transform: translateY(20px); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        .modal-header {
          display: flex;
          justify-content: space-between !important;
          align-items: center;
          padding: 20px 24px !important;
          border-bottom: 1px solid var(--border-color);
          background-color: #ee373b;
        }
        #modal-title {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: white;
        }
        .close-btn-modal {
          background: none;
          border: none;
          font-size: 24px;
          font-weight: bold;
          color: white;
          cursor: pointer;
          transition: color var(--transition-speed);
        }
        .close-btn-modal:hover {
          color: var(--danger-color);
        }
        .vehicle-summary {
          padding: 20px 24px;
          align-items: center;
          border-bottom: 1px solid var(--border-color);
          display: flex;
          gap: 1rem;
        }
        .vehicle-summary h3 {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: var(--text-primary);
        }
        .reg-number {
          margin: 0;
          font-size: 16px;
          font-weight: 600;
          color: var(--text-primary);
        }
        #edit-car-form {
          padding: 24px;
        }
        .form-row {
          margin-bottom: 20px;
        }
        .form-row label {
          display: block;
          margin-bottom: 8px;
          font-size: 12px;
          font-weight: 500;
          color: var(--text-primary);
        }
        .input-with-icon {
          position: relative;
        }
        .currency-symbol {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: var(--text-secondary);
          font-weight: 500;
        }
        #edit-car-form input[type="text"] {
          width: 100%;
          padding: 10px 10px 10px 32px;
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius);
          font-size: 14px;
          transition: all var(--transition-speed);
        }
        #edit-car-form input[type="text"]:focus {
          outline: none;
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
        }
        .toggle-container {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .toggle-switch {
          position: relative;
          display: inline-block;
          width: 40px;
          height: 22px;
        }
        .toggle-switch input {
          opacity: 0;
          width: 0;
          height: 0;
        }
        .slider {
          position: absolute;
          cursor: pointer;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: #ccc;
          transition: .4s;
          border-radius: 34px;
        }
        .slider:before {
          position: absolute;
          content: "";
          height: 14px;
          width: 14px;
          left: 3px;
          bottom: 4px;
          background-color: white;
          transition: .4s;
          border-radius: 50%;
        }
        input:checked + .slider {
          background-color: var(--secondary-color);
        }
        input:checked + .slider:before {
          transform: translateX(20px);
        }
        .toggle-label {
          font-size: 12px;
          font-weight: 500;
        }
        .date-inputs {
          margin-bottom: 10px;
        }
        .date-range-container {
          display: flex;
          gap: 16px;
        }
        .date-input-group {
          flex: 1;
        }
        .date-input-group label {
          font-size: 11px;
          color: var(--text-secondary);
          margin-bottom: 6px;
          display: block;
        }
        #edit-car-form input[type="date"] {
          width: 100%;
          padding: 10px;
          border: 1px solid var(--border-color);
          border-radius: var(--border-radius);
          font-size: 12px;
          transition: all var(--transition-speed);
          font-family: inherit;
        }
        #edit-car-form input[type="date"]:focus {
          outline: none;
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.2);
        }
        .modal-footer {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          padding: 20px 24px;
          border-top: 1px solid var(--border-color);
        }
        #modal-ok-button, #modal-cancel-button {
          padding: 10px 16px;
          border-radius: var(--border-radius);
          font-size: 12px;
          font-weight: 500;
          cursor: pointer;
          transition: all var(--transition-speed);
        }
        #modal-ok-button {
          background-color: #ee373b;
          color: white;
          border: none;
        }
        #modal-ok-button:hover {
          background-color: #27ae60;
          box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        }
        #modal-cancel-button {
          background-color: white;
          color: var(--text-primary);
          border: 1px solid var(--border-color);
        }
        #modal-cancel-button:hover {
          background-color: var(--bg-secondary);
          border-color: var(--text-secondary);
        }
        @media (max-width: 768px) {
          .filters-container {
            flex-direction: column;
          }
          .search-container, .price-filter {
            width: 100%;
            min-width: 100%;
          }
          #search-input {
            width: 100%;
          }
          #car-table {
            display: none;
          }
          .cars-grid {
            grid-template-columns: 1fr;
          }
        }
        @media (min-width: 769px) {
          .cars-grid {
            display: none;
          }
        }
        @media (max-width: 480px) {
          .car-management-container {
            padding: 10px;
          }
          .page-header h1 {
            font-size: 20px;
          }
          .edit-button-disabled, .edit-button-enabled {
            padding: 6px 10px;
            font-size: 12px;
          }
          #modal-content, #image-modal-content {
            width: 100%;
            border-radius: 0;
            height: 100%;
            display: flex;
            flex-direction: column;
          }
          .modal-header {
            padding: 16px;
          }
          .vehicle-summary {
            padding: 16px;
          }
          #edit-car-form {
            padding: 16px;
            flex: 1;
            overflow-y: auto;
          }
          .modal-footer {
            padding: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default CarTable;
